﻿import $ from "jquery";

const validators = {
    multiselect: {
        parameters: ["minselected"],
        isValid: function (value, element, params) {
            var minSelected = parseInt(params.minselected, 10) || 0;

            if (minSelected === 0)
                return true;

            var checkedCount = $('input[name="' + element.name + '"]:checked').length;

            return checkedCount >= minSelected;
        },
        unpack: function (options) {
            options.rules["multiselect"] = options.params;
            options.messages["multiselect"] = options.message;
        }
    }
};

function closeAllMultiSelects(except) {
    $('[data-select-container].focused').not(except).each(function () {
        toggleMultiSelect(this);
    });
}

function toggleMultiSelect(container) {
    $(container).toggleClass('focused');
    var target = $(container).data('options-target');
    $(target).toggleClass('d-none');
}

function setupMultiSelect() {
    $('[data-select-container]').on('click', function () {
        const clickedDropdown = this;
        closeAllMultiSelects(clickedDropdown);
        toggleMultiSelect(clickedDropdown);
    });

    $('[data-select-options] label').on('click', function () {
        var options = $(this).closest('[data-select-options]');
        var container = options.siblings('[data-select-container]');
        var checkedOptions = options.find('label input:checked');

        var text;
        if (checkedOptions.length == 0) {
            text = container.data('select-none');
        } else if (checkedOptions.length == 1) {
            text = $(checkedOptions[0]).next().text();
        } else {
            text = container.data("select-multiple");
        }

        container.find('span').text(text);
    });

    $('body').on('click', function (e) {
        if ($(e.target).closest('[data-select-container], [data-select-options]').length) {
            return;
        }
        closeAllMultiSelects()
    });
}

export { validators, setupMultiSelect };